import { autoinject } from "aurelia-framework";
import { BaseDeviceChart } from "./base-device-chart";
import { Api } from "../../../services/api";
import { Device } from "../../../models/device";
import { MeasurementViewModel } from "../../../models/measurement-view-model";
import { TemperatureFormatValueConverter } from "../../../converters/temperature-format"
import { DielectricPermittivityFormatValueConverter } from "../../../converters/dielectric-permittivity-format"
import { VolumetricWaterContentFormatValueConverter } from "../../../converters/volumetric-water-content-format"
import * as moment from "moment";
import { I18N } from "aurelia-i18n"

@autoinject
export class DecentlabT12SoilMoistureChart extends BaseDeviceChart {

	constructor(api: Api, i18N: I18N) {
		super(api, i18N);
	}

	activate(device: Device) {
		this.bindDevice(device);
	}

	attached() {
		setTimeout(() => {
				this.isAttached = true;
			},
			100);
	}

	protected processData(measurements: MeasurementViewModel[]) {
		if (measurements.length > 0) {
			this.chartData.labels = [];
			this.chartData.datasets[0].data = [];
			this.chartData.datasets[1].data = [];
			this.chartData.datasets[2].data = [];
			this.chartData.datasets[3].data = [];
			measurements.forEach((item: MeasurementViewModel) => {
				this.chartData.labels.push(moment(item.data.timestamp));
				this.chartData.datasets[0].data.push(item.data.dielectricPermittivity ? item.data.dielectricPermittivity.toFixed(2) : 0);
				this.chartData.datasets[1].data.push(item.data.volumetricWaterContent ? item.data.volumetricWaterContent.toFixed(2) : 0);
				this.chartData.datasets[2].data.push(this.convertTemperature(item.data.soilTemperature));
				this.chartData.datasets[3].data.push(item.data.electricalConductivity ? item.data.electricalConductivity.toFixed(2) : 0);
			});
			this.chart.refreshChart();
		}
	}


	protected configureChartAxes() {

		this.chartData = {
			labels: [],
			type: 'line',
			datasets: [
				{
					label: `Dielectric Permittivity`,
					fill: false,
					borderColor: "rgba(0,255,127,1)",
					pointColor: "rgba(0,255,127,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,255,127,1)",
					yAxisID: "DielectricPermittivity",
					data: []
				},
				{
					label: "Volumetric Water Content (m³⋅m⁻³)",
					fill: false,
					borderColor: "rgba(255,0,0,1)",
					pointColor: "rgba(255,0,0,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(255,0,0,1)",
					yAxisID: "VolumetricWaterContent",
					data: []
				},
				{
					label: `Soil Temperature (${this.getTemperatureSymbol()})`,
					fill: false,
					borderColor: "rgba(0,0,255,1)",
					pointColor: "rgba(0,0,255,1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(0,0,255,1)",
					yAxisID: "Temperature",
					data: []
				},
				{
					label: `Electrical Conductivity (µS⋅cm⁻¹)`,
					fill: false,
					borderColor: "rgba(191, 0, 191, 1)",
					pointColor: "rgba(191, 0, 191, 1)",
					pointStrokeColor: "#fff",
					pointHighlightFill: "#fff",
					pointHighlightStroke: "rgba(191, 0, 191, 1)",
					yAxisID: "ElectricalConductivity",
					data: []
				},
			]
		};
	}

	protected configureChartOptions() {
		this.chartOptions = {
			responsive: true,
			maintainAspectRatio: false,
			lineTension: 0.4,
			hover: {
				mode: "dataset"
			},
			legend: {
				display: true
			},
			scales: {
				xAxes: [
					{
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Timestamp"
						},
					}
				],
				yAxes: [
					{
						id: "DielectricPermittivity",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Dielectric Permittivity"
						},
						position: "right"
					},
					{
						id: "VolumetricWaterContent",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Volumetric Water Content (m³⋅m⁻³)"
						},
						position: "left"
					},
					{
						id: "Temperature",
						display: true,
						scaleLabel: {
							display: true,
							labelString: `Soil Temperature  (${this.getTemperatureSymbol()})`
						},
						position: "right"
					},
					{
						id: "ElectricalConductivity",
						display: true,
						scaleLabel: {
							display: true,
							labelString: "Electrical Conductivity (µS⋅cm⁻¹)"
						},
						position: "left"
					}
				]
			}
		};
	}
}
